export default __webpack_public_path__ + "static/media/dublicateJob.23c0f846.svg";